module.exports = __webpack_public_path__ + "img/LBS1.50661e5b.webp";